import _ from 'lodash'
import { all, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects'

import { getApiUrl } from 'services/selectors'
import { validateField, validateFields } from 'common/validator'
import { requests } from 'common/requests'
import lang from 'lang'

import {
  addFieldError,
  clearFieldError,
  RESET_PASSWORD_REQUEST,
  resetPasswordFailure,
  resetPasswordSuccess,
  VALIDATE_RESET_PASSWORD_FIELD,
} from './actions'

function* resetPasswordSaga({
  payload,
}: {
  payload: {
    password: { value: string; validations?: string }
    jwt: { value: string; validations?: string }
  }
}): Generator<unknown, void, unknown> {
  const errors = validateFields(
    payload as unknown as Parameters<typeof validateFields>[0],
  ) as Record<string, string | undefined>

  if (_.isEmpty(errors)) {
    const apiURL = (yield select(getApiUrl)) as string
    try {
      yield call(requests.post, {
        url: `${apiURL}/rpc/reset_password`,
        headers: {
          Authorization: `Bearer ${payload.jwt.value}`,
          Prefer: 'params=single-object',
        },
        data: { new_password: payload.password.value },
      })
      yield put(resetPasswordSuccess())
      return
    } catch (error: unknown) {
      yield put(
        resetPasswordFailure({
          base: _.get(error, 'response.data.message', lang.unhandledServerError) as string,
        }),
      )
      return
    }
  } else {
    yield put(resetPasswordFailure(errors as Record<string, string>))
  }
}

export function* validateFieldSaga({
  payload: { field, value, validations },
}: {
  payload: { field: string; value: string; validations?: string }
}): Generator<unknown, void, unknown> {
  const error = validateField({ field, value, fieldValidations: validations ?? '' })
  const errorStr = typeof error === 'string' ? error : error != null ? String(error) : undefined
  if (errorStr) {
    yield put(addFieldError({ field, error: errorStr }))
  } else {
    yield put(clearFieldError({ field }))
  }
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    // @ts-expect-error redux-saga string action type
    takeLatest(RESET_PASSWORD_REQUEST, resetPasswordSaga),
    // @ts-expect-error redux-saga string action type
    takeEvery(VALIDATE_RESET_PASSWORD_FIELD, validateFieldSaga),
  ])
}
